'use client'

import { ComponentProps, useCallback, useEffect, useState } from 'react'

import { cn } from './style'

export const SCROLL_EVENT = 'scroll-change'

type Props = ComponentProps<'div'>

export const ScrollProgressBar = ({ className, ...props }: Props) => {
  const [progress, setProgress] = useState(0)

  const handleScroll = useCallback(() => {
    const scrollTop = window.scrollY
    const docHeight = document.documentElement.scrollHeight - window.innerHeight
    const scrollPercent = (scrollTop / docHeight) * 100

    const clampedProgress = Math.min(Math.max(scrollPercent, 0), 100)

    setProgress(clampedProgress)
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    window.addEventListener(SCROLL_EVENT, handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener(SCROLL_EVENT, handleScroll)
    }
  }, [handleScroll])

  return (
    <div className={cn('h-1 w-full bg-gray-100', className)} {...props}>
      <div
        className="h-1 w-full bg-purple-500"
        style={{ width: `${progress}%` }}
      />
    </div>
  )
}
